export default __webpack_public_path__ + "static/desktop_KV17-bd215db3e892a034f0051a6ac7aa0340.mp4";